"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreRelationsExporter = void 0;
var tslib_1 = require("tslib");
var base_1 = require("./base");
var CoreRelationsExporter = (function (_super) {
    tslib_1.__extends(CoreRelationsExporter, _super);
    function CoreRelationsExporter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CoreRelationsExporter.prototype, "filePath", {
        get: function () { return '_rels/.rels'; },
        enumerable: false,
        configurable: true
    });
    CoreRelationsExporter.prototype.fillWriter = function () {
        this.addRel(this.data.idGenerator.documentRelationId, this.data.constants.rels.officeDocumentType, 'word/document.xml');
        this.addRel(this.data.idGenerator.calcCorePropertiesDocumentRelationId(), this.data.constants.rels.corePropertiesNamespace, 'docProps/core.xml');
    };
    return CoreRelationsExporter;
}(base_1.RelationsBaseExporter));
exports.CoreRelationsExporter = CoreRelationsExporter;
